import { useTranslate } from '@repo/shared/hooks'
import { Badge } from '@repo/ui/components'
import { cn } from '@repo/ui/lib'

export interface LevelsBadgeProps {
  level: number
  noNumber?: boolean
}

export function LevelsBadge({ level, noNumber }: LevelsBadgeProps) {
  const { t } = useTranslate()

  const levelDescription = [
    t('common_level_1_description'),
    t('common_level_2_description'),
    t('common_level_3_description'),
    t('common_level_4_description'),
    t('common_level_5_description'),
  ]
  const levelColor = [
    'bg-bronze-gradient',
    'bg-silver-gradient',
    'bg-gold-gradient',
    'bg-diamond-gradient',
    'bg-advisor-gradient',
  ]
  return (
    <Badge
      color='custom'
      variant='custom'
      className={cn(
        levelColor[level - 1],
        'px-xs py-3xs rounded-full text-black-70',
      )}
    >
      {noNumber
        ? levelDescription[level - 1]
        : `${levelDescription[level - 1]}`}
    </Badge>
  )
}
